
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {
	Container,
	ContainerWhite,
	CenterWithLogo,
	Center,
	TextCenter,
} from "../components/basic";
import Link from "next/link";
import { Pages } from "../lib/pages";
import { Logo } from "../components/images";
import { GooglePlay, AppStore } from "../components/badge";


const layoutProps = {
  
};
const MDXLayout = ({ children }) => (
	<CenterWithLogo>
		<Center>
			<ContainerWhite>
				<Container>
					<TextCenter>{children}</TextCenter>
				</Container>
			</ContainerWhite>
		</Center>
	</CenterWithLogo>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`První krok do světa `}<strong parentName="h1">{`programování`}</strong></h1>
    <p>{`Codeventure je moderní počítačová hra, která má za cíl
usnadnit první krok do světa logického myšlení a programování.
Připojte se do světa Codeventure a začněte hrát ještě dnes!
Staňte se kouzelníkem a pomozte zachránit jeho planetku.
Sám to ale nezvládnete. Nasbítejte všechny magické kameny,
postavte se zlu a znovu oživte svojí zničenou planetku.
Pro správné kouzlení je potřeba sada kartiček a mobilní aplikace.
Seskládejte sadu příkazů ve správném formátu za sebe a úspěšně
dokončete jednotlivé úrovně. Kouzelnický svět je i pro úplné
začátečníky. Má za úkol vychovat z každého kouzelníka začátečníka
úspěšného mága.`}</p>
    <p>{`Hra Codeventure vznikala jako studentský projekt
`}<strong parentName="p">{`Michala Maděry`}</strong>{` & `}<strong parentName="p">{`Josefa Kahouna`}</strong></p>
    <p><strong parentName="p">{`Codeventure©`}</strong></p>
    <Link href={Pages.Cards} passHref mdxType="Link">
	Seznam kartiček
    </Link>
    <br />
    <Link href={Pages.PrivacyPolicy} passHref mdxType="Link">
	Ochrana osobních údajů
    </Link>
    <br />
    <Link href={Pages.TermAndConditions} passHref mdxType="Link">
	Podmínky používání
    </Link>
    <br />
    <Link href="/codeventure.apk" passHref mdxType="Link">
	APK ke stažení
    </Link>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;